import { type PropsWithChildren } from 'react';

import { Threshold } from '../core/components/sparkline-display/slots/Threshold.js';
import { XAxis } from '../core/components/sparkline-display/slots/XAxis.js';
import { YAxis } from '../core/components/sparkline-display/slots/YAxis.js';
import { SparklineDisplay } from '../core/components/sparkline-display/SparklineDisplay.js';
import type { SparklineProps } from '../core/components/sparkline-display/types/sparkline-props.js';
import { iterateSparklineSlots } from '../core/components/sparkline-display/utils/iterate-sparkline-slots.js';
import { EmptyStateSlot } from '../core/slots/chart-states/EmptyStateSlot.js';
import { ErrorStateSlot } from '../core/slots/chart-states/ErrorStateSlot.js';

const SparkLineRoot = ({
  children,
  ...props
}: PropsWithChildren<SparklineProps>) => {
  const slots = iterateSparklineSlots(children);

  return (
    <SparklineDisplay
      {...props}
      thresholds={slots.thresholds}
      xAxis={slots.xAxis}
      yAxis={slots.yAxis}
    >
      {children}
    </SparklineDisplay>
  );
};

SparkLineRoot['displayName'] = 'Sparkline';

/**
 * The `Sparkline` is a compact and simple data visualization that displays
 * a trend or pattern of data in a small, condensed format. It typically consists
 * of a single line or area graph, without axes or labels, that represents the
 * variation of data points over time.

* @public
*/
export const Sparkline = Object.assign(SparkLineRoot, {
  Threshold,
  EmptyState: EmptyStateSlot,
  ErrorState: ErrorStateSlot,
  XAxis,
  YAxis,
});
